export default __webpack_public_path__ + "static/mobile_KV15-3dc868830762ea94af2087a341faac3d.mp4";